import styled, { css } from 'styled-components'
import { Image, Icon, ImageProps } from 'semantic-ui-react'

interface StyledImageProps extends ImageProps {
  square?: boolean
}

export const ImageWrapper = styled.div`
  position: relative;
`

export const StyledImage = styled(
  ({ square, circular, ...rest }: StyledImageProps) => <Image {...rest} />,
)`
  ${({ square, circular }) => css`
    ${square &&
    css`
      object-fit: cover;
      width: 50px;
      height: 50px;
    `};

    ${circular &&
    css`
      border-radius: 100%;
      width: 50px;
      height: 50px;
    `};
  `}
  position: relative;
`

export const EditIcon = styled(Icon).attrs({
  name: 'edit',
})`
  &&& {
    position: absolute;
    right: 0;
    top: 5px;
    z-index: 1;
    cursor: pointer;
    color: ${props => props.theme.primaryColor};
  }
`
